export default __webpack_public_path__ + "10a87aed958f983ef826acdfe644da1d.svg";